import { render } from "./TungstenFabric.vue?vue&type=template&id=3aa641ba"
import script from "./TungstenFabric.vue?vue&type=script&lang=js"
export * from "./TungstenFabric.vue?vue&type=script&lang=js"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__